/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { CarModelBodyType } from './CarModelBodyType';
import type { CarModelVehicleType } from './CarModelVehicleType';

export interface CarModelSimple {
    id: number;
    /** min length: 1, max length: 45 */
    name: string;
    seats: number;
    body_type: CarModelBodyType | null;
    vehicle_type: CarModelVehicleType;
}
